(function(){
    // scrolling logos optimize logos
    const IOoptions = {
        root: null,
        threshold: 0.01
    };
    
    const IOcallback = function(entries, observer) {
         entries.forEach((entry) => {
            if ( entry.isIntersecting ) {
              const imgs = entry.target.querySelectorAll( 'img' );
              imgs.forEach( (img) => {
                img.loading = 'eager';
              });
            }
         });
    }

    const Iobserver = new IntersectionObserver(IOcallback, IOoptions);  
    
    const logoScrollers = document.querySelectorAll( '.logo-scroller--logos' );
    logoScrollers.forEach( (ls) => {
      Iobserver.observe( ls );
    });
        
    // scroll to referral section on Yotpo page
    var qps = new URLSearchParams( window.location.search );

    if ( qps.get( 'scroll-to-referral' ) !== null ) {
      var t = setInterval( function() {
        var YotpoTarget = document.querySelector( '[yotpo-instance-id="315059"] .yotpo-screen-customer_email' );

        if ( YotpoTarget !== null ) {
          console.log( 'found the container' );
          clearInterval( t );
          setTimeout( function() {
            window.scrollTo( 0, YotpoTarget.offsetTop );
          }, 1000 );
        }
      }, 500 );
    }
    
    // listeners for Rebuy Cart/SmartCart and Klaviyo
    var _learnq = window._learnq || [];
    
    function addedToCart() {
      fetch(`${window.location.origin}/cart.js`)
      .then(res => res.clone().json().then(data => {
        var cart = {
          total_price: data.total_price/100,
          $value: data.total_price/100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price/100,
          items: data.items
        }
        
        if (typeof(item) !== 'undefined') {
          cart = Object.assign(cart, item)
        }

        //_learnq.push(['track', 'Added to Cart', cart])
      }))
    } 
    
    (function (ns, fetch) {
      ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        response.then(res => {
          if (`${window.location.origin}/cart/add.js`
          	.includes(res.url)) {
            	addedToCart()
          }
        });
        return response
      }
    }(window, window.fetch))
    
    let rebuySmartCartReady = false;
    
    if ( rebuySmartCartReady === false ) {
      document.addEventListener( 'rebuy:smartcart.ready', ( event ) => {
        rebuySmartCartReady = true;

        document.addEventListener( 'rebuy:cart.add', ( event ) => {
          //const item = event.detail.item;
          addedToCart();			
        });
      });
    }
    
    const sheetDesktopMinWidth = 1024;
    
    function shouldRedraw() {
      let redraw = false;
      let device = 'desktop';
      
      if ( window.innerWidth < sheetDesktopMinWidth ) {
        device = 'mobile';
      }
      
      const cheatSheets = document.querySelectorAll( '.cheat-sheet--table' );
      for ( const [index, cs] of cheatSheets.entries() ) {
        if ( cs.dataset.drawn != device ) {
          redraw = device;
          break;
        } 
      }
      
      return redraw;
    }
    
    function redrawSheets( device ) {
      // comparision tables
      const cheatSheets = document.querySelectorAll( '.cheat-sheet--table' );
      cheatSheets.forEach( (cs) => {
        if ( device == 'desktop' && $( '.cheat-sheet--table-slider' ).hasClass( '.slick-slider' ) ) {
          $( '.cheat-sheet--table-slider' ).slick( 'unslick' );
        }
        
        const sliderContainer = cs.querySelector( '.cheat-sheet--table-slider-container' );
        if ( sliderContainer != null ) {
          sliderContainer.remove();
        }
        
        const extras = cs.querySelectorAll( '.cheat-sheet--table-column:not(.cheat-sheet--table-left)' );
        extras.forEach( (e) => {
          e.remove();
        });
        
        const type = cs.dataset.sheetType;
        let csJSON = document.getElementById( 'cheat-sheet--json' );
        
        if ( type != null && csJSON != null ) {
          csJSON = JSON.parse( csJSON.innerText );
          const stylers = csJSON;
          const propertyOrder = ["product","texture_type","hold","volume","definition","nourishes","texture","hydrating","frizz","heat","humudity","flyaways","smooths","memory","shine"];
          let stylerColumnsHTML = '';
          
          if ( device == 'mobile' ) {
            stylerColumnsHTML += '<div class="cheat-sheet--table-slider-container"><div class="cheat-sheet--table-slider">';
          }
          
          stylers.forEach( (s) => {
            stylerColumnsHTML += '<div class="cheat-sheet--table-column">';
                      
            propertyOrder.forEach( (p) => {
              let dataValue = s[p];
              let value = null;
              
              switch( typeof( dataValue ) ) {
                case 'boolean':
                  if ( dataValue === true ) {
                    value = '<span class="cheat-sheet--circle cheat-sheet--circle-true"></span>';
                  }
                  else if ( dataValue === false ) {
                    value = '<span class="cheat-sheet--circle cheat-sheet--circle-false"></span>';
                  }
                  break;
                  
                case 'number':
                case 'string':
                  value = dataValue;
                  break;
                  
                default:
                  break;
              }
              
              if ( p == 'product' || p == 'texture_type' ) {
                stylerColumnsHTML += `<div class="cheat-sheet--table-column-header">${value}</div>`;
              }
              else {
                stylerColumnsHTML += `<div class="cheat-sheet--table-cell">${value}</div>`;
              }
            });
            
            stylerColumnsHTML += '</div>';
          });
          
          if ( device == 'mobile' ) {
            stylerColumnsHTML += '</div></div>';
          }
          
          cs.innerHTML += stylerColumnsHTML;
          cs.dataset.drawn = device;
          
          if ( device == 'mobile' && ! $( '.cheat-sheet--table-slider' ).hasClass( '.slick-slider' ) ) {
            const sheetSlider = $( '.cheat-sheet--table-slider' );
            
            sheetSlider.slick({
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: false,
              dots: false,
              arrows: true,
              autoplay: false,
              swipeToSlide: true,
              prevArrow: '<div class="icon--root icon--prev"><div></div><div></div><div></div></div>',
              nextArrow: '<div class="icon--root icon--next"><div></div><div></div><div></div></div>',
              responsive: [
                {
                  breakpoint: 860,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 700,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 520,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
            });
          }
        }
      });
    }

    function checkRedraw() {
      console.log( 'checking if we should redraw' );
      const redraw = shouldRedraw();
      if ( false !== shouldRedraw() ) {
        console.log( 'we SHOULD redraw' );
        redrawSheets( redraw );
      }
    }
  
    checkRedraw();
    
    window.addEventListener( 'resize', checkRedraw );
    window.addEventListener( 'orientationchange', checkRedraw );
    
    $( 'body' ).on( 'click', '.ingredient-list--item:not(.active)', function() {
      const clicked = $( this );
      const parent = clicked.parents( '.ingredient-list--wrapper' );
      const clickedIndex = parseInt( clicked.data( 'index' ) );
      
      parent.find( '.ingredient-list--item.active, .ingredient-list--item-detail.active' ).removeClass( 'active' );
      parent.find( '.ingredient-list--item[data-index="' + clickedIndex + '"], .ingredient-list--item-detail[data-index="' + clickedIndex + '"]').addClass( 'active' );
      
      if ( window.innerWidth <= 960 ) {
        $( 'html, body' ).animate( { scrollTop: ( parent.offset().top - 120 ) + 'px' }, 300 );
      }
    });
    
    $( 'body' ).on( 'click', '.faq-list--item-question', function() {
      const clicked = $( this );
      const parent = clicked.parents( '.faq-list--item' );
      parent.toggleClass( 'active' );
    });
    
    $( 'body' ).on( 'click', '.product--grid-atc', function(e) {
        e.preventDefault();
      const clicked = $( this );
      const parent = clicked.parents( '.product--root' );
      parent.find( '.product--quick-add' ).click();
    });
 }());